import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { LoginPage } from './routes/LoginPage.js';
import { ProductSelectionPage } from './routes/ProductSelectionPage.js';
import { DashboardPage } from './routes/DashboardPage.js';
import { RegisterCopLopPage } from './routes/RegisterCopLopPage.js';
import { RegisterM8Page } from './routes/RegisterM8Page.js';
import { DeviceListPage } from './routes/DeviceListPage.js';
import { DeviceDetailsPage } from './routes/DeviceDetailsPage.js';
import { ServicesPage } from './routes/ServicesPage.js';
import { InstallersPage } from './routes/InstallersPage.js';
import { UsersPage } from './routes/UsersPage.js';
import { AdminsPage } from './routes/AdminsPage.js';
import { SettingsPage } from './routes/SettingsPage.js';
import { ThemePage } from './routes/ThemePage.js';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Product selection — protected but outside the main layout */}
      <Route path="/select-products" element={
        <ProtectedRoute>
          <ProductSelectionPage />
        </ProtectedRoute>
      } />

      <Route element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard"                element={<DashboardPage />} />
        <Route path="/settings"                 element={<SettingsPage />} />
        <Route path="/theme"                    element={<ThemePage />} />
        <Route path="/devices/registered"       element={<Navigate to="/devices" replace />} />
        <Route path="/devices/register"         element={<Navigate to="/devices/register/cop-lop" replace />} />
        <Route path="/devices/register/cop-lop" element={<RegisterCopLopPage />} />
        <Route path="/devices/register/m8"      element={<RegisterM8Page product="m8" />} />
        <Route path="/devices/register/avira"   element={<RegisterM8Page product="avira" />} />
        <Route path="/devices/cop-lop"          element={<DeviceListPage />} />
        <Route path="/devices/m8"               element={<DeviceListPage />} />
        <Route path="/devices/avira"             element={<DeviceListPage />} />
        <Route path="/devices/:id"              element={<DeviceDetailsPage />} />
        <Route path="/devices"                  element={<DeviceListPage />} />
        <Route path="/services"                 element={<ServicesPage />} />
        <Route path="/installers"               element={<InstallersPage />} />
        <Route path="/users"                    element={<UsersPage />} />
        <Route path="/admins"                   element={<AdminsPage />} />
        <Route path="*"                         element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}
